import axios from "axios";

const BASE_URL = import.meta.env.VITE_API_BASE_URL ?? "http://localhost:4000/api/v1";
export const ASSET_BASE = import.meta.env.VITE_PUBLIC_ASSET_BASE ?? "http://localhost:4000";

/**
 * Public-site axios instance. No credentials, no auth — public endpoints
 * are read-only and rate-limited at the prefix.
 */
export const api = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
});

/**
 * Convert a backend-stored /uploads/... path to an absolute URL the browser
 * can fetch. Already-absolute URLs pass through unchanged.
 */
export function assetUrl(relativePath) {
  if (!relativePath) return "";
  if (/^https?:\/\//i.test(relativePath)) return relativePath;
  return `${ASSET_BASE}${relativePath.startsWith("/") ? "" : "/"}${relativePath}`;
}

/**
 * Pick the best variant URL for a given image. The upload pipeline produces
 * /uploads/.../foo.jpg + foo-thumb.webp + foo-md.webp + foo-lg.webp. Most UI
 * uses the original; Phase 12 polish can swap thumbnails on cards.
 */
export function variantUrl(originalPath, variant = "md") {
  if (!originalPath) return "";
  const suffixes = { thumbnail: "-thumb", md: "-md", lg: "-lg" };
  const suffix = suffixes[variant];
  if (!suffix) return assetUrl(originalPath);
  const dot = originalPath.lastIndexOf(".");
  if (dot === -1) return assetUrl(originalPath);
  const base = originalPath.slice(0, dot);
  return assetUrl(`${base}${suffix}.webp`);
}

/**
 * Unwrap the standard {ok, message, data, meta?} envelope.
 */
export async function get(path, params) {
  const response = await api.get(path, { params });
  return {
    data: response.data?.data,
    meta: response.data?.meta,
  };
}
